module.exports = __webpack_public_path__ + "img/newyear_login.da7ec1b2.png";